// wasteDisposalForm/paperWork/actions.js

export const makeWasteDisposalFormPaperWorkActions = ({
  setWasteDisposalUi,
  bump,
  emitWdPatch,
}) => ({
  updateWdSamplesTakenYes(wdData, samplesTakenYes, emitPatch) {
    wdData.basicInfo.updateSamplesTakenYes(samplesTakenYes);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        samplesTakenYes: wdData.basicInfo.samplesTakenYes,
        samplesTakenNo: wdData.basicInfo.samplesTakenNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdSamplesTakenNo(wdData, samplesTakenNo, emitPatch) {
    wdData.basicInfo.updateSamplesTakenNo(samplesTakenNo);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        samplesTakenYes: wdData.basicInfo.samplesTakenYes,
        samplesTakenNo: wdData.basicInfo.samplesTakenNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdSamplesSentTo(wdData, samplesSentTo, emitPatch) {
    wdData.basicInfo.updateTextAttribute("samplesSentTo", samplesSentTo);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ samplesSentTo });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdChainOfCustodyYes(wdData, chainOfCustodyYes, emitPatch) {
    wdData.basicInfo.updateChainOfCustodyYes(chainOfCustodyYes);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        chainOfCustodyYes: wdData.basicInfo.chainOfCustodyYes,
        chainOfCustodyNo: wdData.basicInfo.chainOfCustodyNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdChainOfCustodyNo(wdData, chainOfCustodyNo, emitPatch) {
    wdData.basicInfo.updateChainOfCustodyNo(chainOfCustodyNo);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        chainOfCustodyYes: wdData.basicInfo.chainOfCustodyYes,
        chainOfCustodyNo: wdData.basicInfo.chainOfCustodyNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdMsdsYes(wdData, msdsYes, emitPatch) {
    wdData.basicInfo.updateMsdsYes(msdsYes);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        msdsYes: wdData.basicInfo.msdsYes,
        msdsNo: wdData.basicInfo.msdsNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdMsdsNo(wdData, msdsNo, emitPatch) {
    wdData.basicInfo.updateMsdsNo(msdsNo);
    if (emitPatch) {
      // Send both Yes and No since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        msdsYes: wdData.basicInfo.msdsYes,
        msdsNo: wdData.basicInfo.msdsNo,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdLocationOfContainers(wdData, locationOfContainers, emitPatch) {
    wdData.basicInfo.updateTextAttribute(
      "locationOfContainers",
      locationOfContainers
    );
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ locationOfContainers });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdLetterOfAgencyYes(wdData, letterOfAgencyYes, emitPatch) {
    wdData.basicInfo.updateLetterOfAgencyYes(letterOfAgencyYes);
    if (emitPatch) {
      // Send all three since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        letterOfAgencyYes: wdData.basicInfo.letterOfAgencyYes,
        letterOfAgencyNo: wdData.basicInfo.letterOfAgencyNo,
        letterOfAgencyNa: wdData.basicInfo.letterOfAgencyNa,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdLetterOfAgencyNo(wdData, letterOfAgencyNo, emitPatch) {
    wdData.basicInfo.updateLetterOfAgencyNo(letterOfAgencyNo);
    if (emitPatch) {
      // Send all three since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        letterOfAgencyYes: wdData.basicInfo.letterOfAgencyYes,
        letterOfAgencyNo: wdData.basicInfo.letterOfAgencyNo,
        letterOfAgencyNa: wdData.basicInfo.letterOfAgencyNa,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdLetterOfAgencyNa(wdData, letterOfAgencyNa, emitPatch) {
    wdData.basicInfo.updateLetterOfAgencyNa(letterOfAgencyNa);
    if (emitPatch) {
      // Send all three since they are mutually exclusive
      const patch = wdData.basicInfo.toPatch({
        letterOfAgencyYes: wdData.basicInfo.letterOfAgencyYes,
        letterOfAgencyNo: wdData.basicInfo.letterOfAgencyNo,
        letterOfAgencyNa: wdData.basicInfo.letterOfAgencyNa,
      });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },

  updateWdComments(wdData, comments, emitPatch) {
    wdData.basicInfo.updateTextAttribute("comments", comments);
    if (emitPatch) {
      const patch = wdData.basicInfo.toPatch({ comments });
      emitWdPatch(patch, emitPatch);
    }
    bump();
  },
});
